import { useState } from "react";

export interface ExportMenuProps {
  onDownloadKmz: () => void;
  onOfflineSavestate: () => void;
  busy: boolean;
}

export function ExportMenu(
  { onDownloadKmz, onOfflineSavestate, busy }: ExportMenuProps,
): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="vmc-tbtn"
        data-tour="viewer.export"
        disabled={busy}
        onClick={() => setOpen((v) => !v)}
      >
        {busy ? "Exporting…" : "Export ▾"}
      </button>
      {open && (
        <div role="menu" className="vmc-export-menu">
          <button
            type="button"
            role="menuitem"
            className="vmc-export-menu-item"
            onClick={() => { setOpen(false); onDownloadKmz(); }}
          >
            Download KMZ
          </button>
          <button
            type="button"
            role="menuitem"
            className="vmc-export-menu-item"
            onClick={() => { setOpen(false); onOfflineSavestate(); }}
          >
            Download for offline use
          </button>
        </div>
      )}
    </div>
  );
}
